
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fulladia/[slug]",
      function () {
        return require("private-next-pages/fulladia/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fulladia/[slug]"])
      });
    }
  